import styles from './DatePicker.module.scss';
import { DatePicker as AntdDatePicker } from 'antd';
import type { DatePickerProps } from 'antd/es/date-picker';

import dayjs from 'dayjs';
import 'dayjs/locale/ru';
import cn from 'classnames';

dayjs.locale('ru');

interface IDatePickerProps extends DatePickerProps {
  label?: string;
}

const DatePicker = ({
  className,
  label,
  placeholder = 'Дата',
  value,
  onChange,
  maxDate,
  disabled,
  ...props
}: IDatePickerProps) => {
  return (
    <AntdDatePicker
      className={cn(className, styles.input)}
      placeholder={placeholder}
      format="DD.MM.YYYY"
      onChange={onChange}
      value={value}
      maxDate={maxDate}
      disabled={disabled}
      {...props}
    />
  );
};

export { DatePicker };
